import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { useAuth } from "../provider/authProvider";
import { ProtectedRoute } from "./ProtectedRoute";
import ActivityAdd from "../pages/dashboard/ActivityAdd";
import ActivityAdd2 from "../pages/dashboard/ActivityAdd2";
import ActivityEdit from "../pages/dashboard/ActivityEdit";
import Home from "../pages/Home";
import Logout from "../pages/Logout";
import SubjectCategories from "../pages/dashboard/SubjectCategories";
import FavoriteSubjectCategories from "../pages/dashboard/FavoriteSubjectCategories";
import CategoryActivities from "../pages/dashboard/CategoryActivities";
import CategoryAdd from "../pages/dashboard/CategoryAdd";
import SubjectAdd from "../pages/dashboard/SubjectAdd";
import SubjectEdit from "../pages/dashboard/SubjectEdit";
import SubjectList from "../pages/dashboard/SubjectList";
import AccountCreate from "../pages/AccountCreate";
import CategoryList from "../pages/dashboard/CategoryList";
import CategoryEdit from "../pages/dashboard/CategoryEdit";
import PasswordChange from "../pages/dashboard/PasswordChange";
import Profile from "../pages/dashboard/Profile";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import AccountActivation from "../pages/AccountActivation";
import TermsConditions from "../pages/TermsConditions";
import PrintPage from "../pages/PrintPage";
import Survey from "../pages/dashboard/Survey";
import WeeklyForm from "../pages/dashboard/WeeklyForm";
import WeeklyList from "../pages/dashboard/WeeklyList";

const Routes = () => {
  const { token } = useAuth();

  // Define public routes accessible to all users
  const routesForPublic = [
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/account/create",
      element: <AccountCreate />,
    },
    {
      path: "/password/forgot",
      element: <ForgotPassword />,
    },
    {
      path: "/password/reset",
      element: <ResetPassword />,
    },
    {
      path: "/account/activate",
      element: <AccountActivation />,
    },
    {
      path: "/about-us",
      element: <div>About Us</div>,
    },
    {
      path: "/terms-conditions",
      element: <TermsConditions />,
    },
  ];

  // Define routes accessible only to authenticated users
  const routesForAuthenticatedOnly = [
    {
      path: "/",
      element: <ProtectedRoute />, // Wrap the component in ProtectedRoute
      children: [
        {
          path: "/dashboard",
          element: <SubjectCategories />,
        },
        {
          path: "/dashboard/",
          element: <SubjectCategories />,
        },
        {
          path: "/dashboard/activity/add",
          element: <ActivityAdd />,
        },
        {
          path: "/dashboard/activity/add/v2",
          element: <ActivityAdd2 />,
        },
        {
          path: "/dashboard/activity/edit/:id",
          element: <ActivityEdit />,
        },
        {
          path: "/dashboard/activity/saved",
          element: <SubjectCategories />,
        },
        {
          path: "/dashboard/activity/favorites",
          element: <FavoriteSubjectCategories />,
        },
        {
          path: "/dashboard/category/add",
          element: <CategoryAdd />,
        },
        {
          path: "/dashboard/category/list",
          element: <CategoryList />,
        },
        {
          path: "/dashboard/category/:id/edit",
          element: <CategoryEdit />,
        },
        {
          path: "/dashboard/category/:id",
          element: <CategoryActivities />,
        },
        {
          path: "/dashboard/subject/add",
          element: <SubjectAdd />,
        },
        {
          path: "/dashboard/subject/edit/:id",
          element: <SubjectEdit />,
        },
        {
          path: "/dashboard/subject/list",
          element: <SubjectList />,
        },
        {
          path: "/dashboard/profile",
          element: <Profile />,
        },
        {
          path: "/dashboard/password/change",
          element: <PasswordChange />,
        },
        {
          path: "/dashboard/logout",
          element: <Logout />,
        },
        {
          path: "/print",
          element: <PrintPage />,
        },
        {
          path: "/dashboard/survey",
          element: <Survey />,
        },
        {
          path: "/dashboard/weekly/add",
          element: <WeeklyForm />,
        },
        {
          path: "/dashboard/weekly/list",
          element: <WeeklyList />,
        },
        {
          path: "/dashboard/weekly/edit/:week",
          element: <WeeklyForm />,
        },
      ],
    },
  ];

  // Define routes accessible only to non-authenticated users
  const routesForNotAuthenticatedOnly = [
    {
      path: "/",
      element: <Home />,
    },
  ];

  // Combine and conditionally include routes based on authentication status
  const router = createBrowserRouter([
    ...routesForPublic,
    ...(!token ? routesForNotAuthenticatedOnly : []),
    ...routesForAuthenticatedOnly,
  ]);

  // Provide the router configuration using RouterProvider
  return <RouterProvider router={router} />;
};

export default Routes;
